import { render, staticRenderFns } from "./contract-milestones.component.vue?vue&type=template&id=e0b3e00e"
import script from "./contract-milestones.component.vue?vue&type=script&lang=ts"
export * from "./contract-milestones.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports